import { useAuth } from "shared/lib/useAuth"

import { useProjectPhasesQuery } from "entities/projects/graphql/project-phases/queries.generated"

export function useProjectPhases() {
  const { isAuthenticated } = useAuth()
  const { data, loading } = useProjectPhasesQuery({ skip: !isAuthenticated })
  return { projectPhases: data?.projectPhases, isLoading: loading }
}
